import React from 'react';
import { ChevronRight, ChevronLeft, ShoppingBag, DollarSign } from 'lucide-react';

const StoreSummary = ({ day, data, onStoreClick, onBack }) => {
  const dateLabel = new Date(day.date + 'T12:00:00').toLocaleDateString('en-US', {
    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
  });

  return (
    <div className="store-summary">
      <div className="summary-nav">
        <button className="back-btn" onClick={onBack}>
          <ChevronLeft size={16} /> Back to dates
        </button>
        <div className="summary-nav-title">
          <h2>{dateLabel}</h2>
          <p className="summary-nav-sub">
            Total: <strong>${day.total.toFixed(2)}</strong> at {data.length} {data.length === 1 ? 'store' : 'stores'}
          </p>
        </div>
      </div>

      <div className="store-list">
        {data.map((store) => (
          <button key={store.expense_id}
            className="store-card"
            onClick={() => onStoreClick(store)}>
            <div className="store-card-icon">
              <ShoppingBag size={20} />
            </div>
            <div className="store-card-info">
              <p className="store-name">{store.store_name}</p>
              <div className="store-meta">
                <span>{store.item_count} items</span>
                {store.tax > 0 && (
                  <span>Tax: ${store.tax.toFixed(2)}</span>
                )}
              </div>
            </div>
            <div className="store-card-right">
              <span className="store-total">
                <DollarSign size={14} />
                {store.total.toFixed(2)}
              </span>
              <ChevronRight size={16} color="#555" />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default StoreSummary;
